<template>
  <c-box
    font-size="sm"
    line-height="1.2"
    height="auto"
    border-radius="input"
    :bg="bg"
    mb="xs"
    font-weight="semibold"
    :_hover="{
      color: 'brand.blueLight',
      cursor: 'pointer',
    }"
    tabindex="0"
    @click="getAttachmentURL()"
    @keydown.enter="getAttachmentURL()"
  >
    <c-flex align="center" justify="space-between" pl="2xs" pr="md" my="-2px">
      <c-flex align="center" justify="center" ml="2xs" mr="xs">
        <Spinner v-if="loadingAttachmentURL" size="sm"></Spinner>
        <c-icon v-else name="download" size="1rem" />
      </c-flex>
      <c-text my="2xs" as="span" font-size="xs">
        {{ attachmentName }}
      </c-text>
    </c-flex>
  </c-box>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import Spinner from "@/components/Spinner.vue";
import Icon from "@/design-system/elements/Icon.vue";
import { CBox, CFlex, CIcon, CText } from "@chakra-ui/vue";

export default defineComponent({
  name: "DownloadSupportRequestAttachment",
  components: {
    Spinner,
    CBox,
    CIcon,
    CFlex,
    CText,
    Icon,
  },
  props: {
    messageId: {
      type: String,
    },
    attachmentId: {
      type: String,
      required: true,
    },
    ticketId: {
      type: String,
      required: true,
    },
    attachmentName: {
      type: String,
      required: true,
    },
    bg: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      loadingAttachmentURL: false,
    };
  },

  methods: {
    async getAttachmentURL() {
      if (!this.loadingAttachmentURL) {
        this.loadingAttachmentURL = true;
        const { ticketId, messageId, attachmentId } = this;

        const url = messageId
          ? await this.$store.dispatch("solutions/fetchConversationAttachmentURL", {
              ticketId,
              messageId,
              attachmentId,
            })
          : await this.$store.dispatch("solutions/fetchTicketAttachmentURL", {
              ticketId,
              attachmentId,
            });

        if (url) {
          window.open(url, "_blank");
        }

        this.loadingAttachmentURL = false;
      }
    },
  },
});
</script>
